import Dexie from 'dexie';

const db = new Dexie('prodmandb');
db.version(7).stores({
  departments: '++id,name',
  executions: '++id,date,department_id,kind,status',
  local_executions: 'id,date,department_id,kind,status',
  categories: 'id,code'
});
db.open();

export default db;